import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class HeroSliderThree extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.state = {
            isLoading: true
        };
    }

    next() {
        this.slider.slickNext();
    }

    previous() {
        this.slider.slickPrev();
    }

    componentDidMount() {
        // Delay for 5 seconds before showing the slider, consistent with HeroSliderTwo behavior
        setTimeout(() => {
            this.setState({ isLoading: false });
        }, 2000);
    }

    render() {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            arrows: false // We will use custom arrows
        };

        const data = [
            { bgImg: 's2.jpg', sliderTitle: 'Building Excellence, Delivering Results', sliderSubtitle: 'Your trusted partner in construction and infrastructure development. We transform visions into reality with precision engineering and unwavering commitment to quality.', btnLink: 'contact-us' },
            { bgImg: 's3.jpg', sliderTitle: 'Infrastructure That Works', sliderSubtitle: 'Innovative solutions for complex construction challenges. From groundbreaking to completion, we deliver projects that stand the test of time.', btnLink: 'contact-us' },
            { bgImg: 's1.jpg', sliderTitle: 'Precision. Quality. Reliability.', sliderSubtitle: 'Industry-leading construction services backed by cutting-edge equipment and expert craftsmanship. Building the future, one project at a time.', btnLink: 'contact-us' }
        ];

        // Maintain a minimum height for the loader container to avoid layout shift
        if (this.state.isLoading) {
            return (
                <div className="hero-slider-area" style={{ height: '750px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
                    <div className="loader"></div>
                </div>
            );
        }

        return (
            <div>
                {/*====================  hero slider area ====================*/}
                <div className="hero-slider-area position-relative">
                    <Slider ref={c => (this.slider = c)} {...settings}>
                        {data.map((val, i) => (
                            <div key={i}>
                                <div className="hero-slider__single-item" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/others/${val.bgImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                                    <div className="hero-slider__content-wrapper">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="hero-slider__content m-auto text-center">
                                                        <h2 className="hero-slider__title">{val.sliderTitle}</h2>
                                                        <p className="hero-slider__text">{val.sliderSubtitle}</p>
                                                        <a className="hero-slider__btn hero-slider__btn--style2" href={`${process.env.PUBLIC_URL}/${val.btnLink}`}> GET STARTED</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                    {/* Custom Arrows mimicking Swiper buttons */}
                    <button type="button" className="ht-swiper-button-prev ht-swiper-button-nav d-none d-xl-block prev-swiper-nav" onClick={this.previous}>
                        <i className="ion-ios-arrow-left" />
                    </button>
                    <button type="button" className="ht-swiper-button-next ht-swiper-button-nav d-none d-xl-block next-swiper-nav" onClick={this.next}>
                        <i className="ion-ios-arrow-forward" />
                    </button>
                </div>
                {/*====================  End of hero slider area  ====================*/}
            </div>
        );
    }
}

export default HeroSliderThree;